import { Routes } from '@angular/router'
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { AuthGuard } from './auth/auth.guard';
import { Page1Component } from './page1/page1.component';
import { MenuComponent } from './menu/menu.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { MainPageComponent } from './main-page/main-page.component';
import { ListUserComponent } from './user-management/list-user/list-user.component';
import { UserManagementService } from './service/user-management.service';
import { UpdateUserComponent } from './user-management/update-user/update-user.component';
import { CreateUserComponent } from './user-management/create-user/create-user.component';
import { MessageComposeComponent } from './message/message-compose/message-compose.component';
import { MessageViewComponent } from './message/message-view/message-view.component';
import { RecipientsListComponent } from './recipient-management/recipients/recipients-list/recipients-list.component';
import { RecipientEditComponent } from './recipient-management/recipients/recipient-edit/recipient-edit.component';
import { GroupListComponent } from './group-management/group-list/group-list.component';
import { GroupEditComponent } from './group-management/group-edit/group-edit.component';
import { GroupRecipientListComponent } from './group-management/group-recipient-list/group-recipient-list.component';
import { SuppliersListComponent } from './supplier-management/suppliers/suppliers-list/suppliers-list.component';
import { SupplierEditComponent } from './supplier-management/suppliers/supplier-edit/supplier-edit.component';
import { NewDocumentComponent } from './document/new-document/new-document.component';
import { CustomerOrderListComponent } from './order/customer-order/customer-order-list/customer-order-list.component';
import { SupplierOrderListComponent } from './order/supplier-order/supplier-order-list/supplier-order-list.component';
import { SupplierInvoiceSendComponent } from './invoice/supplier-invoice/supplier-invoice-send/supplier-invoice-send.component';
import { CustomerInvoiceListComponent } from './invoice/customer-invoice/customer-invoice-list/customer-invoice-list.component';
import { CustomerInvoiceDetailsComponent } from './invoice/customer-invoice/customer-invoice-details/customer-invoice-details.component';
import { SupplierInvoiceListComponent } from './invoice/supplier-invoice/supplier-invoice-list/supplier-invoice-list.component';
import { SupplierInvoiceDetailsComponent } from './invoice/supplier-invoice/supplier-invoice-details/supplier-invoice-details.component';
import { ReportCustomerInvoiceComponent } from './report/report-customer-invoice/report-customer-invoice.component';
import { LPInvoiceDetailsComponent } from './lp/lp-invoice-details/lp-invoice-details.component';
import { ReportBudgetUtilizationComponent } from './report/report-budget-utilization/report-budget-utilization.component';
import { NewDocumentProfitComponent } from './document/new-document-profit/new-document-profit.component';
import { NewOrderComponent } from './new-order/new-order.component';
import { UpdateOrderComponent } from './update-order/update-order.component';
import { AddItemComponent } from './add-item/add-item.component';
import { UpdateItemComponent } from './update-item/update-item.component';
import { EquipmentSignComponent } from './equipment-sign/equipment-sign.component';
import { AddClientComponent } from './add-client/add-client.component';
import { EditClientComponent } from './edit-client/edit-client.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { CallRequestDetailsComponent } from './call-request-details/call-request-details.component';
import { CallsReportComponent } from './calls-report/calls-report.component';
import { EditCallTypeComponent } from './edit-call-type/edit-call-type.component';

export const appRoutes: Routes = [
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'page1', component: Page1Component, canActivate: [AuthGuard] },
    {
        path: 'signup', component: UserComponent,
        children: [{ path: '', component: SignUpComponent }]
    },
    {
        path: 'login', component: UserComponent,
        children: [{ path: '', component: SignInComponent }]
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'menu', component: MenuComponent },
    { path: 'main-page', component: MainPageComponent },
    { path: 'list-user', component: ListUserComponent },
    { path: 'update-user/:id', component: UpdateUserComponent },
    { path: 'create-user', component: CreateUserComponent },

    { path: 'message-compose', component: MessageComposeComponent },
    // { path: 'message-view/:m/:g', component: UserComponent,
    //     children: [{ path: '', component: SignUpComponent }]
    // },
    // { path: 'message-view/:m/:g', component: MessageViewComponent },
    { path: 'message-view', component: MessageViewComponent },

    { path: 'recipients-list', component: RecipientsListComponent },
    { path: 'recipient-edit', component: RecipientEditComponent },
    { path: 'recipient-edit/:id', component: RecipientEditComponent },

    { path: 'group-list', component: GroupListComponent },
    { path: 'group-edit', component: GroupEditComponent },
    { path: 'group-edit/:id', component: GroupEditComponent },
    { path: 'group-recipient-list', component: GroupRecipientListComponent },
    
    { path: 'suppliers-list', component: SuppliersListComponent },
    { path: 'supplier-edit', component: SupplierEditComponent },
    { path: 'supplier-edit/:id', component: SupplierEditComponent },

    { path: 'new-document', component: NewDocumentComponent },
    { path: 'customer-order-list', component: CustomerOrderListComponent },
    { path: 'supplier-order-list', component: SupplierOrderListComponent },
    //{ path: 'supplier-invoice-send/:order', component: SupplierInvoiceSendComponent },
    { path: 'supplier-invoice-send', component: SupplierInvoiceSendComponent },
    { path: 'customer-invoice-list', component: CustomerInvoiceListComponent },
    //{ path: 'customer-invoice-details/:invoice', component: CustomerInvoiceDetailsComponent },
    { path: 'customer-invoice-details', component: CustomerInvoiceDetailsComponent },
    { path: 'supplier-invoice-list', component: SupplierInvoiceListComponent },
    //{ path: 'supplier-invoice-details/:invoice', component: SupplierInvoiceDetailsComponent },
    { path: 'supplier-invoice-details', component: SupplierInvoiceDetailsComponent },
    { path: 'report-customer-invoice', component: ReportCustomerInvoiceComponent },
    { path: 'report-budget-utilization', component: ReportBudgetUtilizationComponent },
    //{ path: 'lpi/:invoice', component: LPInvoiceDetailsComponent },
    { path: 'lpi', component: LPInvoiceDetailsComponent },

    { path: 'new-document-profit/:id', component: NewDocumentProfitComponent },

    { path: 'new-document-profit', component: NewDocumentProfitComponent },

    { path: 'error-page/:id', component: ErrorPageComponent },
    { path: "newOrder", component: NewOrderComponent },
    { path: "updateOrder", component : UpdateOrderComponent },
    { path: "addItem", component: AddItemComponent },
    { path: "updateItem", component: UpdateItemComponent },
    { path: "equipmentSign/:orderId", component: EquipmentSignComponent },

    { path: "addClient", component: AddClientComponent },
    { path: "clientManagment", component:EditClientComponent },

    { path: "clientDetails/:id", component: ClientDetailsComponent },

    { path: 'callRequestDetails/:callId', component: CallRequestDetailsComponent },

    { path:"callsReport", component: CallsReportComponent },

    { path: "editCallType", component:EditCallTypeComponent },

    { path: "**", component: ErrorPageComponent },
];



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/routes.ts